import {
  FiUsers,
  FiGift,
  FiCalendar,
  FiSearch,
  FiBookOpen,
  FiHeart,
  FiTool,
  FiTrendingUp,
  FiGlobe,
  FiAward,
  FiZap,
} from 'react-icons/fi'
import type { PartnershipOption, PartnerReason } from '@/types/partnership'

export const partnershipOptions: PartnershipOption[] = [
  {
    Icon: FiUsers,
    title: 'Strategic Partnerships',
    text: 'Long-term collaboration aligned with shared goals and mutual impact.',
  },
  {
    Icon: FiGift,
    title: 'Programme Sponsorship',
    text: 'Fund and support specific programmes that empower communities.',
  },
  {
    Icon: FiCalendar,
    title: 'Event Sponsorship',
    text: 'Partner on conferences, festivals, and signature IBON World events.',
  },
  {
    Icon: FiSearch,
    title: 'Research Collaboration',
    text: 'Joint research that informs policy and development across the regions.',
  },
  {
    Icon: FiBookOpen,
    title: 'Educational Exchange',
    text: 'Cross-regional learning and exchange programmes for students and leaders.',
  },
  {
    Icon: FiHeart,
    title: 'CSR Initiatives',
    text: 'Corporate social responsibility partnerships that create lasting good.',
  },
  {
    Icon: FiTool,
    title: 'Capacity-Building Support',
    text: 'Technical, mentorship, and institutional strengthening support.',
  },
]

export const partnerTypes: string[] = [
  'Governments',
  'Universities & Educational Institutions',
  'Embassies & Diplomatic Missions',
  'Development Agencies',
  'Non-Governmental Organisations',
  'Foundations',
  'Corporations & Businesses',
  'Financial Institutions',
]

export const partnerReasons: PartnerReason[] = [
  { Icon: FiTrendingUp, text: 'Expand impact and reach more communities' },
  { Icon: FiGlobe, text: 'Support sustainable development initiatives' },
  { Icon: FiAward, text: 'Empower young entrepreneurs and emerging leaders' },
  { Icon: FiZap, text: 'Promote innovation and cultural exchange' },
  { Icon: FiUsers, text: 'Strengthen communities through collaborative action' },
]
